import { type ReactNode } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { LoadingSpinner } from '../common/LoadingSpinner'

interface RequireSuperadminSalonDashboardProps {
  children: ReactNode
}

/** Tijdelijk: salondashboard alleen voor superadmin; eigenaar/team → agenda. */
export function RequireSuperadminSalonDashboard ({
  children,
}: RequireSuperadminSalonDashboardProps) {
  const { salonId } = useParams<{ salonId: string }>()
  const { loading, profileLoading, isSuperadmin } = useAuth()

  if (loading || profileLoading) return <LoadingSpinner />
  if (!salonId) return <Navigate to="/login" replace />
  if (!isSuperadmin) return <Navigate to={`/login/${salonId}/agenda-v2`} replace />

  return <>{children}</>
}
